import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CategoriesService } from '../../services/categories.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LocalizedName } from '../../models/localized-name.model';
import { ConfigService } from '../../services/config.service';
import { Language } from '../../models/language.model';
import { Category } from '../../models/questions';
import { QuestionCategoryType } from '../../models/questions/question-category-type.enum';

export class ModalBase {
  private languages: Array<Language>;
  constructor(
    private categoriesService: CategoriesService,
    private modalData: Category,
    private appData: ConfigService
  ) {
    this.getAllLanguages();
  }

  saveOnEdit(data: Category, modalRef: BsModalRef) {
    this.categoriesService.update(data).subscribe((x) => {
      modalRef.hide();
      this.categoriesService.saveOnEditCategoryClicked(data);
    });
  }

  saveOnAdd(data: Category, modalRef: BsModalRef) {
    this.categoriesService.create(data).subscribe((x) => {
      if (modalRef) {
        modalRef.hide();
      }
      this.categoriesService.saveOnAddCategoryClicked(data);
    });
  }

  mapFormvalueToCategory(formValue: object, partOfControlName) {
    const localizedNames: Array<LocalizedName> = [];
    for (const key in formValue) {
      if (
        formValue.hasOwnProperty(key) &&
        key.indexOf(partOfControlName) >= 0
      ) {
        this.languages.forEach((lang) => {
          if (key.indexOf(lang.code) >= 0) {
            localizedNames.push({ locale: lang.code, name: formValue[key] });
          }
        });
      }
    }
    return localizedNames;
  }

  getCheckBoxes(modalForm: FormGroup) {
    this.mapCheckboxesValues(modalForm);
    return modalForm.get('checkboxes')['controls'];
  }

  mapCheckboxesValues(modalForm: FormGroup) {
    const checkboxesControls: Array<FormControl> = modalForm.get('checkboxes')[
      'controls'
    ];
    this.modalData.questionCategoryTypes = checkboxesControls
      .map((x, i) => {
        if (x.value) {
          return Math.pow(2, i - 1);
        }
      })
      .filter((x) => x);
  }

  buildCheckboxControls(fb: FormBuilder) {
    let formValue;
    const formControl: Array<FormControl> = [];
    for (const key in QuestionCategoryType) {
      if (!isNaN(parseInt(key, 10))) {
        formValue = this.modalData.questionCategoryTypes.find((x) => {
          return +x === +key;
        })
          ? true
          : false;
        formControl.push(new FormControl(formValue));
      }
    }
    return fb.array(formControl);
  }

  private getAllLanguages() {
    this.languages = this.appData.getLanguages;
  }
}
